import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const FileIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M12.8334 2.08057V5.8669C12.8334 6.38028 12.8334 6.63697 12.9333 6.83305C13.0211 7.00553 13.1614 7.14577 13.3339 7.23365C13.5299 7.33356 13.7866 7.33356 14.3 7.33356H18.0863M12.8334 15.5835H7.33335M14.6667 11.9168H7.33335M18.3334 9.15604V15.7668C18.3334 17.307 18.3334 18.077 18.0336 18.6653C17.77 19.1827 17.3493 19.6034 16.8318 19.8671C16.2436 20.1668 15.4735 20.1668 13.9334 20.1668H8.06669C6.52654 20.1668 5.75647 20.1668 5.16821 19.8671C4.65077 19.6034 4.23007 19.1827 3.96642 18.6653C3.66669 18.077 3.66669 17.307 3.66669 15.7668V6.2335C3.66669 4.69335 3.66669 3.92328 3.96642 3.33502C4.23007 2.81758 4.65077 2.39688 5.16821 2.13323C5.75647 1.8335 6.52654 1.8335 8.06669 1.8335H11.0108C11.6834 1.8335 12.0198 1.8335 12.3362 1.90948C12.6168 1.97684 12.8851 2.08796 13.1311 2.23874C13.4087 2.4088 13.6465 2.64661 14.1221 3.12223L17.0446 6.04477C17.5202 6.52038 17.758 6.75819 17.9281 7.03571C18.0789 7.28176 18.19 7.55001 18.2574 7.83061C18.3334 8.1471 18.3334 8.48341 18.3334 9.15604Z"
        stroke="#14191F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default FileIcon;
